import {
  APP_INITIALIZER,
  NgModule,
  provideBrowserGlobalErrorListeners,
  isDevMode
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { MyHttpInterceptorService } from './core/interceptor/my-http-interceptor.service';
import { BrandService } from './core/service/brand.service';
import { PISTA_LIVE_TRANSPORT } from './core/service/pista-live-transport';
import { PistaLiveSignalrTransportService } from './core/service/pista-live-signalr-transport.service';
import { PwaSessionBootstrapService } from './core/service/pwa-session-bootstrap.service';

function initializePwaGuestSession(
  pwaSessionBootstrapService: PwaSessionBootstrapService
): () => Promise<void> {
  return () => pwaSessionBootstrapService.initialize();
}

function initializeBrandTheme(brandService: BrandService): () => void {
  return () => brandService.initializeTheme();
}

@NgModule({
  declarations: [
    App
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000'
      })
    
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyHttpInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializePwaGuestSession,
      deps: [PwaSessionBootstrapService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBrandTheme,
      deps: [BrandService],
      multi: true
    },
    {
      provide: PISTA_LIVE_TRANSPORT,
      useExisting: PistaLiveSignalrTransportService
    }
  ],
  bootstrap: [App]
})
export class AppModule { }
